module.exports = __webpack_public_path__ + "images/facebook-08a16a1972965599c2ab2a5eb1bf9b3a.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/facebook.png
// module id = 35
// module chunks = 0